import { RouteType } from "../config";
import HomePage from "../../pages/home/HomePage";

import DashboardPageLayout from "../../components/layout/DashboardPageLayout";

import SolicitacaoPessoalPage from "../../pages/SolicitacaoPessoal/SolicitacaoPessoalPage";
import AssignmentIcon from "@material-ui/icons/Assignment";
import AgendaFolga from "../../pages/AgendaFolga/AgendaFolga";

const grupoSolicitacaoPessoal: RouteType = {
  path: "/",
  show: true,
  element: <DashboardPageLayout />,
  state: "SOLICITACAO_PESSOAL",
  verificarPermissao: (usuario) => {
    return usuario?.perfil.podeAcessarSolicitacoesPessoais ?? false;
  },
  sidebarProps: {
    displayText: "Solicitações Pessoais",
    icon: <AssignmentIcon />,
  },
  child: [
    {
      index: true,
      element: <HomePage />,
      state: "solicitacoes.index",
      show: true,
    },
    {
      path: "/solicitacao_pessoal",
      element: <SolicitacaoPessoalPage />,
      state: "SOLICITACAO",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeAcessarSolicitacoesPessoais ?? false;
      },
      sidebarProps: {
        displayText: "Solicitações",
      },
    },

    {
      path: "/agenda_folga_ferias",
      element: <AgendaFolga />,
      state: "AGENDA_FOLGA_FERIAS",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeAcessarSolicitacoesPessoais ?? false;
      },
      sidebarProps: {
        displayText: "Agenda de Folgas",
      },
    },
  ],
};

export default grupoSolicitacaoPessoal;
